import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { StaffCardSettingsComponent } from '../../classroom360/staff-home/staff-cards/staff-card-settings/staff-card-settings.component';
import { AddAttachmentDialogComponent } from '../../shared-components/add-attachment-dialog/add-attachment-dialog.component';
import { TylerMatTableDataSource } from '../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../shared-components/angular-material/mat-animations';
import { GeneralConfirmationComponent } from '../../shared-components/controls/general-confirmation/general-confirmation.component';
import { StudentService } from '../../shared-components/student/student.service';
import { System } from '../../shared-components/System';
import { UserService } from '../../shared-components/user/user.service';
import { YearService } from '../../shared-components/year/year.service';
import { LoginService } from '../../shared-modules/login/login.service';
import { StudentAttachment } from '../../shared-modules/student-attachment/student-attachment.model';
import { IepService } from '../../student360/iep/iep.service';
import { SpedFixedUserPermission, SpedUserPermission } from '../sped-user-permissions.model';
import { Sped360Service } from '../sped360.service';
import { ViewDocumentComponent } from '../student-document-home/sped-student-document-cards/sped-student-collection-common-card/view-document/view-document.component';
import { SpedCollectionStudentToTeamMember, SpedStudentCollectionCard } from '../student-document-home/sped-student-document-cards/sped-student-document-cards.model';
import { SpedStudentDocumentCardsService } from '../student-document-home/sped-student-document-cards/sped-student-document-cards.service';
import { FormWithinDocumentsService } from './form-within-documents.service';
import { FormListSequence, IepFormsWithinDocuments, ImportedDocuments, OptionalForms, TeamMemberPermission } from './formwithin-document-modal';
import { AddOptionalFormsComponent } from './modals/add-optional-forms/add-optional-forms.component';
import { CheckInCheckOutComponent } from './modals/check-in-check-out/check-in-check-out.component';
import { EditHtmlFormComponent } from './modals/edit-html-form/edit-html-form.component';
import { IndeterminateProgressBarComponent } from './modals/indeterminate-progress-bar/indeterminate-progress-bar.component';
import { ManageTeamComponent } from './modals/manage-team/manage-team.component';

@AutoUnsubscribe()
@Component({
  selector: 'app-forms-within-documents',
  templateUrl: './forms-within-documents.component.html',
  styleUrls: ['./forms-within-documents.component.css'],
  animations: [detailExpand],
})
export class FormsWithinDocumentsComponent implements OnInit, OnDestroy {

  cardSettingsDialog: MatDialogRef<StaffCardSettingsComponent>;
  getIepCollection: IepFormsWithinDocuments[] = [];
  dataField: IepFormsWithinDocuments[] = [];
  importedDocuments: ImportedDocuments[] = [];
  tylerMatData = new TylerMatTableDataSource();
  matDataSource = new TylerMatTableDataSource();
  collectionCard = new SpedStudentCollectionCard();
  columnToDisplay = ['dragHandle', 'CheckAllStatus', 'More', 'TemplateNameHTML', 'CheckedOutByuserName', 'IsOptional', 'IsAllowMultiple', 'LastModifiedDate', 'ModifiedByUserName', 'IsMarkedComplete', 'Actions'];
  columnToDisplayImported = ['Description', 'DocumentName', 'CreatedDate', 'UserName', 'Actions'];
  studentCollectionId: number;
  SpEdCollectionToIEPStatusId: number;
  showLatestVersion = false;
  spEdcollectionId: number;
  studentId: number;
  subscriptions: Subscription[] = [];
  allCheck = false;
  disabledActionMenuItems = true;
  status: string;
  yearId: number;
  selectedView: string;
  isFiltered = false;
  editFormDropDown: IepFormsWithinDocuments[] = [];
  teamMemberRead: SpedCollectionStudentToTeamMember[] = [];
  collectionName: string;
  collectionCode: string;
  spedFixedPermission = new SpedFixedUserPermission();
  spedUserPermission: SpedUserPermission[] = [];
  studentTemplateVersionIds: string;
  printWithoutWorkingDraft = false;
  importDocumentAndAttachToAllSpEdDocuments = false;
  importDocumentAndAttachToAllSpEdDocuments504 = false;
  deleteDocumentPer = false;
  deleteDocumentPer504 = false;
  userId: number;
  isTeamMember: boolean;
  hasPermission: boolean;
  checkOutDocument: boolean;
  checkOutDocument504: boolean;
  maintainTeamMemberPermission: boolean;
  maintainTeamMemberPermission504: boolean;
  viewOnly: boolean;
  getOptionalForms: OptionalForms[] = [];
  formSaveOrDeleted = false;
  formSequence: FormListSequence[] = [];
  selectedForm: OptionalForms[] = [];
  studentChangeSubscription: Subscription;
  addOptionalCheckAll = false;
  selectedOptionalForm: TeamMemberPermission[] = [];
  tempOptionalForms: OptionalForms[] = [];
  expandAllRow = false;
  fileAsBlob: Blob;
  showAsOverlayDialog = false;
  isDocCreator: boolean;
  inactiveSpEdModule = false;

  @ViewChild('sort', { static: true }) sort: MatSort;
  @ViewChild('sort2') sort2: MatSort;

  constructor(private formWithinDocuments: FormWithinDocumentsService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private userService: UserService,
    private yearService: YearService,
    private iepService: IepService,
    private sped360Service: Sped360Service,
    private sanitizer: DomSanitizer,
    private loginService: LoginService,
    private spedStudentDocumentCardsService: SpedStudentDocumentCardsService,
    private studentService: StudentService
  ) {
    this.route.queryParams.subscribe(params => {
      this.selectedView = params['selectedView'];
      this.studentCollectionId = params['collectionToStudentId'];
      this.spEdcollectionId = params['SpedCollectionId'];
      this.studentId = params['Id'];
      this.SpEdCollectionToIEPStatusId = params['lngSpEdCollectionToIEPStatusId'];
      this.collectionName = params['collectionName'];
      this.collectionCode = params['collectionCode'];
      this.status = params['Status'];
    });
    if (this.selectedView != 'CurrentWork' && this.selectedView != 'DocumentWaitingApproval' && this.selectedView != 'MyTeams') {
      this.studentChangeSubscription = this.studentService.selectedStudentStream$.subscribe(
        studentId => {
          if (this.sped360Service.previousSelectedStudentId != studentId && studentId != null) {
            this.sped360Service.previousSelectedStudentId = studentId;
            this.studentDocument();
          }
        });
    }
  }

  ngOnInit(): void {
    this.userId = this.userService.currentUser.Id;
    this.spedFixedPermission = this.sped360Service.spedFixedPermission;
    this.spedUserPermission = this.sped360Service.spedUserPermission;
    this.yearId = this.yearService.defaultYear.Id;
    this.printWithoutWorkingDraft = this.loginService.LoginSettings.AllowPrintWithoutWorkingDraft;
    this.checkOutDocument = this.sped360Service.spedFixedPermission.CheckOutDocument;
    this.checkOutDocument504 = this.sped360Service.spedFixedPermission.CheckOut504Document;
    this.deleteDocumentPer = this.sped360Service.spedFixedPermission.DeleteAllSpEdDocuments || this.sped360Service.spedUserPermission.filter(x => x.CollectionId == this.collectionCard.CollectionId && x.Delete == true).length > 0;
    this.deleteDocumentPer504 = this.sped360Service.spedFixedPermission.DeleteAll504Documents || this.sped360Service.spedUserPermission.filter(x => x.CollectionId == this.collectionCard.CollectionId && x.Delete == true).length > 0;
    this.importDocumentAndAttachToAllSpEdDocuments = this.sped360Service.spedFixedPermission.ImportDocumentAndAttachToAllSpEdDocuments || this.sped360Service.spedUserPermission.filter(x => x.CollectionId == this.collectionCard.CollectionId && x.ImportDocumentAndAttachToDocument == true).length > 0;
    this.importDocumentAndAttachToAllSpEdDocuments504 = this.sped360Service.spedFixedPermission.ImportDocumentAndAttachToAll504Documents || this.sped360Service.spedUserPermission.filter(x => x.CollectionId == this.collectionCard.CollectionId && x.ImportDocumentAndAttachToDocument == true).length > 0;
    this.maintainTeamMemberPermission = this.spedFixedPermission.MaintainTeamMemberPermissionsonDocumentsAndForms;
    this.maintainTeamMemberPermission504 = this.spedFixedPermission.Maintain504TeamMemberPermissionsonDocumentsAndForms;
    this.inactiveSpEdModule = this.loginService.LoginSettings.InactiveSpEdModule;
    if ((!this.collectionCode.includes('504') && this.deleteDocumentPer == false) || (this.collectionCode.includes('504') && this.deleteDocumentPer504 == false)) {
      this.columnToDisplayImported.splice(4, 1);
    }
    this.sped360Service.collectionId = this.spEdcollectionId;
    this.sped360Service.collectionStatus = this.status;
    this.sped360Service.collectionName = this.collectionName;
    this.sped360Service.collectionCode = this.collectionCode;
    this.checkIsTeamMemberPermission();
    this.getIepFormsWithinDocumentData();
    this.checkOptionalFormLength();
    this.getImportedDocuments();
    this.getEditFormDropDown();
  }

  checkOptionalFormLength() {
    this.formWithinDocuments.spedEditAssignedCollectionTemplatesRead(this.studentCollectionId, this.spEdcollectionId).subscribe(formList => {
      this.getOptionalForms = formList;
      this.tempOptionalForms = formList;
      this.setSelectedForm();
    });
  }

  setSelectedForm() {
    this.formWithinDocuments.teamMemberPermissionRead(this.studentCollectionId, this.studentId).subscribe(data => {
      this.selectedOptionalForm = data;
      if (this.status == 'Working Draft' || this.status == 'Completed by Case Manager') {
        if (((!this.collectionCode.includes('504') && !this.spedFixedPermission.MaintainAllSpEdDocuments) || (this.collectionCode.includes('504') && !this.spedFixedPermission.MaintainAll504Documents))
          && (this.spedUserPermission.filter(x => x.CollectionId == this.spEdcollectionId && x.Maintain == false).length > 0)
          && this.isTeamMember == true) {
          if (this.isDocCreator == false) {
            this.tempOptionalForms = [];
            this.getOptionalForms.forEach(setForm => {
              this.selectedOptionalForm.forEach(selectedSetForm => {
                if (setForm.TemplateVersionId == selectedSetForm.SpedTemplateVersionId && selectedSetForm.IsEdit == true) {
                  this.tempOptionalForms.push(setForm);
                }
              });
            });
          }
        }
      }
      this.saveForm();
    });
  }
  saveForm() {
    if (this.status == 'Working Draft' || this.status == 'Completed by Case Manager') {
      if ((!this.collectionCode.includes('504') && this.spedFixedPermission.MaintainAllSpEdDocuments) || (this.collectionCode.includes('504') && this.spedFixedPermission.MaintainAll504Documents)) {
        this.hasPermission = true;
      } else if (this.spedUserPermission.filter(x => x.CollectionId == this.spEdcollectionId && x.Maintain == true).length > 0) {
        this.hasPermission = true;
      }
      else if (this.isTeamMember == true) {
        this.hasPermission = true;
      }
      else {
        this.hasPermission = false;
      }
    }
    if (this.hasPermission == true && this.tempOptionalForms.length > 0) {
      this.viewOnly = false;
    }
    else {
      this.viewOnly = true;
    }
  }

  rowDrop(event: CdkDragDrop<IepFormsWithinDocuments[], IepFormsWithinDocuments[]>) {
    const field = event.item.data;
    const tempIdOfPrevIndex = this.getIepCollection[event.previousIndex].TemplateVersionId;

    const tempIdOfCurrentIndex = this.getIepCollection[event.currentIndex].TemplateVersionId;
    if (tempIdOfPrevIndex == tempIdOfCurrentIndex) {
      moveItemInArray(this.getIepCollection, event.previousIndex, event.currentIndex);
    }
    let index = 0;
    this.formSequence = [];
    this.getIepCollection.forEach((form) => {
      if (tempIdOfPrevIndex == form.TemplateVersionId) {
        const setSequence = new FormListSequence();
        form.Sequence = index;
        index = index + 1;
        setSequence.Sequence = form.Sequence;
        setSequence.TemplateVersionId = form.TemplateVersionId;
        setSequence.StudentCollectionTemplateVersionId = form.StudentCollectionTemplateVersionId;
        this.formSequence.push(setSequence);
      }
    });
    this.formWithinDocuments.checkSequence(this.formSequence).subscribe(() => {
      this.getIepFormsWithinDocumentData();
      this.getEditFormDropDown();
    });
    this.tylerMatData.data = this.getIepCollection;
  }

  checkIsTeamMemberPermission() {
    this.spedStudentDocumentCardsService.spedCollectionStudentToTeamMember(this.studentCollectionId, false).subscribe(data => {
      this.teamMemberRead = data;
      const tempTeamMemberData = this.teamMemberRead;
      tempTeamMemberData.forEach(teamData => {
        if (teamData.TeamMemberId == this.userId) {
          this.isTeamMember = true;
        } else {
          this.isTeamMember = false;
        }
        if (teamData.TeamMemberId == this.userId && teamData.IsCreator == true) {
          this.isDocCreator = true;
        } else {
          this.isDocCreator = false;
        }
      });
    });
  }

  getIepFormsWithinDocumentData() {
    this.formWithinDocuments.spedStudentCollectionStatusTemplatesItemsRead(this.studentCollectionId, this.showLatestVersion, this.spEdcollectionId).subscribe(result => {
      this.getIepCollection = result;
      this.loadPageData();
    });
  }

  loadPageData() {
    this.tylerMatData = new TylerMatTableDataSource(this.getIepCollection);
    if (this.expandAllRow == true) {
      this.expandAllRow = false;
    }
    this.tylerMatData.data = this.getIepCollection;
    this.tylerMatData.sort = this.sort;
    if (this.formSaveOrDeleted == true) {
      this.getEditFormDropDown();
    }
  }

  getEditFormDropDown() {
    this.formWithinDocuments.spedHTMLStudentCollectionStatusTemplatesItemsRead(this.studentCollectionId, false, this.spEdcollectionId).subscribe(ddlData => {
      this.editFormDropDown = ddlData.filter(x => x.DoumentName.includes('MO_37_IEP') == false);
    });
  }

  addAttachment() {
    // Initializing attachment
    const attachment = new ImportedDocuments();
    attachment.StudentId = this.studentId;
    attachment.spedCollectionToStudentId = this.studentCollectionId;
    attachment.DocumentName = '';
    attachment.Description = '';
    attachment.CreatedDate = new Date();
    attachment.UserName = '';

    // Opening modal
    const dialogBox = this.dialog.open<AddAttachmentDialogComponent>(AddAttachmentDialogComponent, {
      data: {
        attachment: attachment,
        newAttachment: true,
        requireDocumentType: true,
        type: 'ImportedDocuments'
      },
      disableClose: true
    });
    this.subscriptions.push(
      dialogBox.afterClosed().subscribe(() => {
        if (dialogBox.componentInstance.saved) {
          attachment.FileBase64 = attachment.MyFileBase64String;
          attachment.DocumentName = attachment.FileName;
          attachment.Description = attachment.Description;
          attachment.CreatedDate = new Date();
          attachment.FileType = attachment.FileExtension;
          if (attachment.FileType.toLowerCase() == 'txt' || attachment.FileType.toLowerCase() == 'rtf') {
            attachment.FileType = 'text/plain';
          }
          else if (attachment.FileType.toLowerCase() == 'doc') {
            attachment.FileType = 'application/msword';
          }
          else if (attachment.FileType.toLowerCase() == 'pdf') {
            attachment.FileType = 'application/pdf';
          }
          else if (attachment.FileType.toLowerCase() == 'docx') {
            attachment.FileType = 'application/vnd.openxmlformats-officedocument.word';
          }
          else if (attachment.FileType.toLowerCase() == 'applicatio') {
            attachment.FileType = 'application/' + attachment.FileType.substr(1);
          }
          else if (attachment.FileType.toLowerCase() == 'jpg') {
            attachment.FileType = 'image/jpg';
          }
          else if (attachment.FileType.toLowerCase() == 'jpeg') {
            attachment.FileType = 'image/jpeg';
          }
          else if (attachment.FileType.toLowerCase() == 'xlsx') {
            attachment.FileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          }
          else if (attachment.FileType.toLowerCase() == 'xls') {
            attachment.FileType = 'application/vnd.ms-excel';
          }
          else if (attachment.FileType.toLowerCase() == 'png') {
            attachment.FileType = 'image/png';
          }
          else if (attachment.FileType.toLowerCase() == 'gif') {
            attachment.FileType = 'image/gif';
          }
          attachment.UserName = this.userService.currentUser.LastName + ', ' + this.userService.currentUser.FirstName;
          this.formWithinDocuments.spedStudentDocumentCreate(attachment, attachment.FileType).subscribe(() => {
            this.getImportedDocuments();
          });
        }
      })
    );
  }
  allowToAddOptionalForm() {
    if (this.status == 'Working Draft' || this.status == 'Completed by Case Manager') {
      if ((!this.collectionCode.includes('504') && this.spedFixedPermission.MaintainAllSpEdDocuments) || (this.collectionCode.includes('504') && this.spedFixedPermission.MaintainAll504Documents)) {
        return true;
      } else if (this.spedUserPermission.filter(x => x.CollectionId == this.spEdcollectionId && x.Maintain == true).length > 0) {
        return true;
      }
      else {
        if (this.isTeamMember == true) {
          this.teamMemberRead.forEach(obj => {
            if (obj.IsCreator == true) {
              return true;
            }
            return false;
          });
          return true;
        } else {
          return false;
        }
      }
    }
    else {
      return false;
    }

  }

  getImportedDocuments() {
    this.formWithinDocuments.spedStudentDocumentRead(this.studentId, this.studentCollectionId).subscribe(data => {
      this.importedDocuments = data;
      this.loadAttachmentData();
    });
  }

  loadAttachmentData() {
    setTimeout(() => {
      this.matDataSource = new TylerMatTableDataSource(this.importedDocuments);
      this.matDataSource.data = this.importedDocuments;
      this.matDataSource.sort = this.sort2;
    }, 0);
  }

  viewDocumentClick(document) {
    if (document.SpedDocumentId != null && document.SpedDocumentId != undefined) {
      const studentAttachment: StudentAttachment = {
        DocumentId: document.SpedDocumentId,
        DocumentBase64: '',
        DocumentMimeType: '',
        DocumentName: '',
        DocumentModuleName: 'Documents',
        ReportParameters: [],
        ReportType: 0
      };
      window.localStorage.setItem('studentAttachment', JSON.stringify(studentAttachment));
      const win = window.open(System.baseUrl + 'studentattachment', '_blank');
      win.focus();
    }
    else {
      let win: any;
      if (!window.navigator) {
        win = window.open(System.baseUrl + 'studentattachment', '_blank');
        this.iepService.viewCollectionDocument(document.SpedCollectionId,
          this.studentId,
          document.SpedCollectionToStudentId,
          document.CollectionStatusId,
          document.TemplateVersionId,
          this.userService.userId,
          this.userService.currentUser.LoginSchoolId,
          this.yearService.student360Year.Id).subscribe(docBase64String => {

            const byteCharacters = atob(docBase64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const FileAsBlob = new Blob([byteArray], { type: 'application/pdf' });
            win.location.href = URL.createObjectURL(FileAsBlob);
          });
      }
    }
  }

  deleteImportedDocuments(dataField: ImportedDocuments) {
    const deleteDialogBox = this.dialog.open(GeneralConfirmationComponent, {
      disableClose: true,
    });
    deleteDialogBox.componentInstance.okButtonLabel = 'Delete';
    deleteDialogBox.componentInstance.headerLabel = 'Delete Document';
    deleteDialogBox.componentInstance.confirmMessage = 'Are you sure you want to delete this Document?';
    deleteDialogBox.afterClosed().subscribe(confirm => {
      if (confirm == true) {
        const SpedDocumentId = dataField.SpedDocumentId;
        this.deleteDocument(SpedDocumentId);
      }
    });

  }

  deleteDocument(SpedDocumentId: number) {
    this.formWithinDocuments.spedStudentDocumentDelete(SpedDocumentId).subscribe(() => {
      this.getImportedDocuments();
    });
  }

  checkAllClick() {
    if (this.allCheck == true) {
      this.getIepCollection.forEach(obj => {
        obj.StatusChecked = true;
      });
    } else if (this.allCheck == false) {
      this.getIepCollection.forEach(obj => {
        obj.StatusChecked = false;
      });
    }
    this.selectedIds();
  }

  chkSingleForm() {
    this.selectedIds();
  }

  selectedIds() {
    this.studentTemplateVersionIds = '';
    this.getIepCollection.forEach(obj => {
      if (obj.StatusChecked == true) {
        if (this.studentTemplateVersionIds == '') {
          this.studentTemplateVersionIds = obj.StudnetXMLId.toString();
        } else {
          this.studentTemplateVersionIds = this.studentTemplateVersionIds + ',' + obj.StudnetXMLId.toString();
        }
      }
    });
  }

  massAction() {
    const studentData = this.tylerMatData.filteredData.filter(o => o.StatusChecked);
    if (!studentData || studentData.length == 0) {
      this.disabledActionMenuItems = true;
    }
    else {
      this.disabledActionMenuItems = false;
    }
  }

  viewEditForm(fs: IepFormsWithinDocuments, formMode: string) {
    this.getUpdatedCheckedByUserId(formMode, fs);
  }

  openForm(fs: IepFormsWithinDocuments, formMode: string) {
    if (formMode == 'View') {
      this.sped360Service.canEditForm = false;
    }
    if (formMode == 'Edit') {
      this.formWithinDocuments.editHtmlFormDialogOpen = true;
      this.sped360Service.canEditForm = true;
      this.sped360Service.continueClicked = true;
    }
    if (formMode == 'Edit' && this.loginService.LoginSettings.AllowCheckInOutSpEdForms == true && this.formWithinDocuments.spedStudentCollectionTemplate.CheckOutByUserId > 0 && this.formWithinDocuments.spedStudentCollectionTemplate.CheckOutByUserId != this.userId) {
      this.checkOutFormDialog(fs);
    } else {
      this.editViewHtmlForm(fs);
    }
  }

  editViewHtmlForm(fs: IepFormsWithinDocuments) {
    const viewOverlayDialog = this.dialog.open(EditHtmlFormComponent, {
      disableClose: true,
      height: '100%',
      width: '100%',
      maxWidth: 'inherit'
    });
    viewOverlayDialog.componentInstance.formStatus = this.status;
    viewOverlayDialog.componentInstance.dataField = fs;
    viewOverlayDialog.componentInstance.ddData = this.editFormDropDown;
    viewOverlayDialog.componentInstance.checkOutDocument = this.checkOutDocument;
    viewOverlayDialog.componentInstance.checkOutDocument504 = this.checkOutDocument504;
    viewOverlayDialog.componentInstance.collectionCode = this.collectionCode;
    viewOverlayDialog.componentInstance.studentFormData = { SpEdcollectionId: this.spEdcollectionId, StudentId: this.studentId, StudentCollectionId: this.studentCollectionId, SpEdCollectionToIEPStatusId: this.SpEdCollectionToIEPStatusId, StudentCollectionTemplateVersionId: fs.StudentCollectionTemplateVersionId, TemplateVersionId: fs.TemplateVersionId, TemplateName: fs.TemplateName, IsEdit: this.sped360Service.canEditForm, StudentXMLDataId: fs.StudnetXMLId, CheckedOutByUserId: fs.CheckedOutByUserId };
    viewOverlayDialog.afterClosed().subscribe(result => {
      this.getIepFormsWithinDocumentData();
      this.getImportedDocuments();
      this.getEditFormDropDown();
    });
  }

  checkOutFormDialog(fs: IepFormsWithinDocuments) {
    const viewCheckOutDialog = this.dialog.open(CheckInCheckOutComponent, {
      disableClose: true,
      height: '35vh',
      width: '40vw',
      maxWidth: 'inherit'
    });
    viewCheckOutDialog.componentInstance.checkedOutBy = this.formWithinDocuments.spedStudentCollectionTemplate.CheckedOutByUserName;
    viewCheckOutDialog.componentInstance.templateName = fs.TemplateName;
    viewCheckOutDialog.componentInstance.collectionCode = this.collectionCode;
    viewCheckOutDialog.afterClosed().subscribe(result => {
      if (result == 'save') {
        this.editViewHtmlForm(fs);
      }
    });
  }

  specialServiceHome() {
    this.router.navigateByUrl('/sped360/spedHome');
  }

  studentDocument() {
    this.router.navigateByUrl('/sped360/studentDocumentHome');
  }

  allowToEditDelete(formWithinDoc: IepFormsWithinDocuments) {
    return this.sped360Service.allowToEditDelete(formWithinDoc.IsEdit);
  }

  copyOfForm(collection: IepFormsWithinDocuments) {
    this.formWithinDocuments.spedCopyAllowMultiple(this.studentCollectionId, collection.TemplateVersionId).subscribe(() => {
      this.getIepFormsWithinDocumentData();
      setTimeout(() => {
        this.getEditFormDropDown();
      }, 200);
    });
  }

  deleteFormOfDocument(dataField: IepFormsWithinDocuments) {
    const deleteDialogBox = this.dialog.open(GeneralConfirmationComponent, {
      disableClose: true,
    });
    deleteDialogBox.componentInstance.okButtonLabel = 'Delete';
    deleteDialogBox.componentInstance.headerLabel = 'Delete Form';
    deleteDialogBox.componentInstance.confirmMessage = 'Are you sure you want to delete the Form?';
    deleteDialogBox.afterClosed().subscribe(confirm => {
      if (confirm == true) {
        const studentCollectionTemplateVersionId = dataField.StudentCollectionTemplateVersionId;
        this.deleteForm(studentCollectionTemplateVersionId);
      }
    });
  }

  markComplete(dataField: IepFormsWithinDocuments, status: boolean) {
    this.formWithinDocuments.spedMarkDocumentCompleted(dataField.StudnetXMLId, status).subscribe(() => {
      this.getIepFormsWithinDocumentData();
      this.getImportedDocuments();
    });
  }

  deleteForm(studentCollectionTemplateVersionId: number) {
    if (this.addOptionalCheckAll) {
      this.addOptionalCheckAll = false;
    }
    this.formWithinDocuments.spedDeleteAssignedTemplate(studentCollectionTemplateVersionId).subscribe(() => {
      this.getIepFormsWithinDocumentData();
      this.checkOptionalFormLength();
      this.formSaveOrDeleted = true;
    });
  }

  addOptionalForms() {
    const OptionalForm = this.dialog.open(AddOptionalFormsComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
      height: '80vh',
      minWidth: '60vw',
    });
    OptionalForm.componentInstance.dialogTitle = this.collectionName + ' ' + '- Optional Forms';
    OptionalForm.componentInstance.tempStudentCollectionId = this.studentCollectionId;
    OptionalForm.componentInstance.collectionId = this.spEdcollectionId;
    OptionalForm.componentInstance.collectionCode = this.collectionCode;
    OptionalForm.componentInstance.isTeamMemberPer = this.isTeamMember;
    OptionalForm.componentInstance.tempStudentId = this.studentId;
    OptionalForm.afterClosed().subscribe(result => {
      if (result == 'save') {
        const assignedTemplateVersionId: number[] = [] = OptionalForm.componentInstance.assignedTemplateVersionIds;
        this.selectedForm = OptionalForm.componentInstance.tempOptionalForms;
        const collectionToStudentId: number = OptionalForm.componentInstance.tempStudentCollectionId;
        this.addOptionalCheckAll = OptionalForm.componentInstance.allCheck;
        this.saveForms(collectionToStudentId, assignedTemplateVersionId);
      }
    });
  }

  saveForms(studentCollectionId: number, templateVersionId: number[]) {
    this.formWithinDocuments.spedEditAssignedCollectionRead(studentCollectionId, templateVersionId).subscribe(() => {
      this.getIepFormsWithinDocumentData();
      this.checkOptionalFormLength();
      this.formSaveOrDeleted = true;
    });
  }

  viewContent(fs: IepFormsWithinDocuments, studentHeader: boolean) {
    const viewOverlayDialogPB = this.dialog.open(IndeterminateProgressBarComponent, {
      disableClose: true,
    });
    viewOverlayDialogPB.componentInstance.spEdcollectionId = this.spEdcollectionId;
    viewOverlayDialogPB.componentInstance.studentId = this.studentId;
    viewOverlayDialogPB.componentInstance.studentCollectionId = this.studentCollectionId;
    viewOverlayDialogPB.componentInstance.spEdCollectionToIEPStatusId = this.SpEdCollectionToIEPStatusId;
    viewOverlayDialogPB.componentInstance.templateVersionId = fs.TemplateVersionId;
    viewOverlayDialogPB.componentInstance.siteId = 0;
    viewOverlayDialogPB.componentInstance.yearId = this.yearId;
    viewOverlayDialogPB.componentInstance.callFromHomePage = false;
    viewOverlayDialogPB.componentInstance.studentTemplateVersionIds = fs.StudnetXMLId.toString();
    viewOverlayDialogPB.componentInstance.studentHeader = studentHeader;
    viewOverlayDialogPB.componentInstance.printType = 0;

    viewOverlayDialogPB.afterClosed().subscribe(result => {
      if (result == 'print') {
        this.fileAsBlob = null;
        this.fileAsBlob = viewOverlayDialogPB.componentInstance.fileAsBlobString;
        this.openPrintView();
      } else {
        this.getIepFormsWithinDocumentData();
        this.getImportedDocuments();
      }

    });

  }

  openPrintView() {
    const viewOverlayDialog = this.dialog.open(ViewDocumentComponent, {
      disableClose: true,
      height: '100%',
      width: '100%',
      maxWidth: 'inherit'
    });
    viewOverlayDialog.componentInstance.formSrc = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(this.fileAsBlob));
    viewOverlayDialog.afterClosed().subscribe(() => {
      this.getIepFormsWithinDocumentData();
      this.getImportedDocuments();
    });
  }
  viewMassContent(studentHeader: boolean) {
    const viewOverlayDialogPB = this.dialog.open(IndeterminateProgressBarComponent, {
      disableClose: true,
    });
    viewOverlayDialogPB.componentInstance.spEdcollectionId = this.spEdcollectionId;
    viewOverlayDialogPB.componentInstance.studentId = this.studentId;
    viewOverlayDialogPB.componentInstance.studentCollectionId = this.studentCollectionId;
    viewOverlayDialogPB.componentInstance.spEdCollectionToIEPStatusId = this.SpEdCollectionToIEPStatusId;
    viewOverlayDialogPB.componentInstance.templateVersionId = 0;
    viewOverlayDialogPB.componentInstance.siteId = 0;
    viewOverlayDialogPB.componentInstance.yearId = this.yearId;
    viewOverlayDialogPB.componentInstance.callFromHomePage = false;
    viewOverlayDialogPB.componentInstance.studentTemplateVersionIds = this.studentTemplateVersionIds;
    viewOverlayDialogPB.componentInstance.studentHeader = studentHeader;
    viewOverlayDialogPB.componentInstance.printType = 0;

    viewOverlayDialogPB.afterClosed().subscribe(result => {
      if (result == 'print') {
        this.allCheck = false;
        this.fileAsBlob = null;
        this.fileAsBlob = viewOverlayDialogPB.componentInstance.fileAsBlobString;
        this.openPrintView();
      } else {
        this.allCheck = false;
        this.getIepFormsWithinDocumentData();
        this.getImportedDocuments();
      }
    });
  }

  clearFilterFromFooter() {
    this.tylerMatData.removeAllFilters();
    this.matDataSource.removeAllFilters();
    this.isFiltered = false;
  }

  maitainTeamClick() {
    const manageTeamDialogRef = this.dialog.open(ManageTeamComponent, {
      disableClose: true,
      minWidth: '100vw',
      maxWidth: '100vw',
      minHeight: '100vh',
      maxHeight: '100vh'
    });
    manageTeamDialogRef.componentInstance.spedCollectionToStudentId = this.studentCollectionId;
    manageTeamDialogRef.componentInstance.collectionName = this.collectionName;
    manageTeamDialogRef.componentInstance.status = this.status;
  }
  allowDeleteFinalStatus() {
    if (this.status == 'Reviewed by Supervisor' || this.status == 'Completed') {
      return false;
    }
    else {
      return true;
    }
  }

  getUpdatedCheckedByUserId(formMode: string, selectedForm: IepFormsWithinDocuments) {
    this.formWithinDocuments.getStudentCollectionTemplate(selectedForm.StudentCollectionTemplateVersionId, selectedForm.TemplateName).subscribe(result => {
      this.formWithinDocuments.spedStudentCollectionTemplate = result;
      this.openForm(selectedForm, formMode);
    });
  }

  checkExpanded(row: any): boolean {
    return this.tylerMatData.checkExpanded(row);
  }

  toggleExpanded(row: any) {
    if (row.DoumentName.indexOf('MO_5_IEPGoalMaint') > 0 || row.DoumentName.indexOf('IL_5_IEPGoalObjectives') > 0 || row.DoumentName.indexOf('NM_10_IEPGoalMaint') > 0 || row.DoumentName.indexOf('OR_6_IEPAAFGO') > 0) {
      this.tylerMatData.toggleExpanded(row);
    }
  }

  expandAllRowClick() {
    this.expandAllRow = !this.expandAllRow;
    for (const row of this.tylerMatData.data.filter(x => x.DoumentName.indexOf('MO_5_IEPGoalMaint') > 0 || x.DoumentName.indexOf('IL_5_IEPGoalObjectives') > 0 || x.DoumentName.indexOf('NM_10_IEPGoalMaint') > 0 || x.DoumentName.indexOf('OR_6_IEPAAFGO') > 0)) {
      row.detailRow = this.expandAllRow;
    }
  }

  ngOnDestroy() { }

}